import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

href: string = "";
hrefB: string = "";
config: any;
headerMenu: any;

  constructor(
  	private router: Router,
  	private appComponent: AppComponent
  	) {
  	this.config = this.appComponent.config;
  	this.headerMenu = this.appComponent.config.headerMenu;

  	router.events.subscribe(val => {
	     if (this.router.url != "/" && this.router.url != this.href) {
	        this.href = this.router.url;
	        this.hrefB = this.href.substring(1);
	    }
    });
   }

  ngOnInit(): void {
	   var vthis = this;


       $(window).on('scroll', function () {
         if ($('.scroll-to-top').length) {
             var strickyScrollPos = 100;
             if ($(window).scrollTop() > strickyScrollPos) {
                 $('.scroll-to-top').fadeIn(500);
             } else if ($(this).scrollTop() <= strickyScrollPos) {
                 $('.scroll-to-top').fadeOut(500);
             }
         }
         if ($('.stricked-menu').length) {
             var headerScrollPos = 100;
             var stricky = $('.stricked-menu');
             if ($(window).scrollTop() > headerScrollPos) {
                 stricky.addClass('stricky-fixed');
             } else if ($(this).scrollTop() <= headerScrollPos) {
                 stricky.removeClass('stricky-fixed');
             }
         }
         vthis.OnePageMenuScroll();
     }); 
  }

  ngAfterViewInit() {
     /*if ($('.stricky').length) {
        $('.stricky').addClass('original').clone(true).insertAfter('.stricky').addClass('stricked-menu').removeClass('original');
    }*/

        var subMenu = $('.main-navigation .sub-menu');
        subMenu.parent('li').children('a').append(function () {
            return '<button class="sub-nav-toggler"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>';
        });
        var mainNavToggler = $('.header-navigation .menu-toggler');
        var subNavToggler = $('.main-navigation .sub-nav-toggler');
        mainNavToggler.on('click', function () {
            var Self = $(this);
            var menu = Self.closest('.header-navigation').find(Self.data('target'));
            $(menu).slideToggle();
            $(menu).toggleClass('showen');
            return false;
        });
        subNavToggler.on('click', function () {
            var Self = $(this);
            Self.parent().parent().children('.sub-menu').slideToggle();
            return false;
        });
    
  }

  OnePageMenuScroll() {
        var windscroll = $(window).scrollTop();
        if (windscroll >= 100) {
            var menuAnchor = $('.one-page-scroll-menu .scrollToLink').children('a');
            menuAnchor.each(function () {
                // grabing section id dynamically
                var sections = $(this).attr('href');
                $(sections).each(function () {
                    // checking is scroll bar are in section
                    if ($(this).offset().top <= windscroll + 100) {
                        // grabing the dynamic id of section
                        var Sectionid = $(sections).attr('id');
                        // removing current class from others
                        $('.one-page-scroll-menu').find('li').removeClass('current');
                        // adding current class to related navigation
                        $('.one-page-scroll-menu').find('a[href*=\\#' + Sectionid + ']').parent().addClass('current');
                    }
                });
            });
        } else {
            $('.one-page-scroll-menu li.current').removeClass('current');
            $('.one-page-scroll-menu li:first').addClass('current');
        }
    }

  scrollToLink(href){
  	if (this.router.url != "/home"){
  		this.router.navigate(['/home']);
  		setTimeout(function(){
  			$([document.documentElement, document.body]).animate({
		        scrollTop: $(href).offset().top
		    }, 1000);
  		}, 100);
  		
  	} else {
  			 $([document.documentElement, document.body]).animate({
		        scrollTop: $(href).offset().top
		    }, 1000);
  	}
   
  }

}
